module.exports = __webpack_public_path__ + "static/media/95065697_248924486467843_8031107390571020288_n.f86852e9.jpg";